


























































































import userStaffType from '@/store/types/userStaff';
import { TeipNotifications } from '@/util/teipNotifications';
import auth from '@/store/types/auth';
import copyObj from '@/util/copyObj';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';

export default Vue.extend({
  name: 'ProfileStaffComponent',
  components: {},
  data: () => ({
    user: {
      profile: {
        first_name: '',
        last_name: '',
      },
    },
    edit: false,
    user_id: '',
  }),
  computed: {
    ...mapGetters({
      userStaff: `userStaff/${userStaffType.getters.GET_SINGLE_USER_STAFF}`,
      currenUser: `authModule/${auth.getters.GET_AUTH_USER}`,
    }),
  },
  mounted() {
    if (this.$route.params.user_id === undefined) {
      this.$data.user_id = this.currenUser.id;
      this.$data.user = copyObj(this.currenUser);
    } else {
      this.$data.user_id = this.userStaff.id;
      this.$data.user = copyObj(this.userStaff);
    }
  },
  methods: {
    ...mapActions({
      updateUserStaff: `userStaff/${userStaffType.actions.UPDATE_USER_STAFF}`,
    }),
    async updateProfile() {
      const notification = new TeipNotifications();
      const newData = this.$data.user;
      delete newData.permission_groups;
      const dataToSend = {
        user_id: this.$data.user_id,
        data: newData,
      };
      if (this.$route.name === 'my-profile') {
        this.$emit('currentUser', newData);
        this.$data.edit = false;
      } else {
        this.updateUserStaff(dataToSend)
          .then(() => {
            notification.success('Actualizado correctamente');
            this.$data.edit = false;
          })
          .catch(() => {
            notification.warning('No hemos podido actualizar el perfil :(');
          });
      }
    },
  },
});
